/**
 * Mock settings data — interim contract for features/settings/*.
 * Roles use the frontend vocabulary (auth-permissions.md) — normalize with the
 * spec's snake_case roles when the real auth backend lands.
 */
export const initialTeamMembers = [
  { id: 'user-agency-001', name: 'Sarah Chen', email: 'sarah@example.com', role: 'agency-admin', status: 'active', lastActive: 'now' },
  { id: 'user-agency-002', name: 'Devon Park', email: 'devon@example.com', role: 'operator', status: 'active', lastActive: '1h ago' },
  { id: 'user-agency-003', name: 'Rin Vasquez', email: 'rin@example.com', role: 'viewer', status: 'invited', lastActive: '—' }
];

export const initialApiKeys = [
  { id: 'key-001', label: 'Production integration', prefix: 'agi_live_7f2c', createdAt: '2026-08-12', lastUsed: '12m ago', scopes: ['read:agents', 'write:approvals'] },
  { id: 'key-002', label: 'Staging CI', prefix: 'agi_test_b91d', createdAt: '2026-09-02', lastUsed: '3d ago', scopes: ['read:agents'] }
];

export const initialWebhooks = [
  { id: 'wh-001', label: 'Ops incident bridge', url: 'https://hooks.example.com/agi/incidents', events: ['approval.required', 'agent.failed'], enabled: true, lastDelivery: '200 OK · 2m ago' },
  { id: 'wh-002', label: 'Analytics mirror', url: 'https://metrics.example.com/agi/stream', events: ['task.completed'], enabled: false, lastDelivery: '—' }
];

export const webhookEventOptions = [
  'approval.required',
  'approval.completed',
  'task.completed',
  'task.failed',
  'agent.failed',
  'agent.autonomy_changed'
];

export const initialAuditLog = [
  { id: 'audit-001', actor: 'Sarah Chen', action: 'agent.autonomy_changed', detail: 'Set Ledger to autonomous', at: '2026-09-19 08:41' },
  { id: 'audit-002', actor: 'Devon Park', action: 'approval.approved', detail: 'APR-2840 · Publish customer story', at: '2026-09-19 07:58' },
  { id: 'audit-003', actor: 'Sarah Chen', action: 'apikey.created', detail: 'Production integration (read:agents, write:approvals)', at: '2026-08-12 11:20' }
];
